import React, { useEffect, useState } from "react";

const PageLoader = () => {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setHidden(true), 900);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className={`page-loader ${hidden ? "hidden" : ""}`} data-testid="page-loader">
      <div className="page-loader-logo">Larcraft<span>.</span></div>
    </div>
  );
};

export default PageLoader;
